<template>
  <div class="mainContainer" v-loading='importLoading'>
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>类型：</p>
        <el-select v-model="queryCriteria.msType" size="mini" filterable style="width: 150px" placeholder="请选择类型">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>起始地：</p>
        <el-input v-model="queryCriteria.startAddressName" size="mini" style="width: 150px" placeholder="请输入起始地" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>目的地：</p>
        <el-input v-model="queryCriteria.endAddressName" size="mini" style="width: 150px" placeholder="请输入目的地" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运输方式：</p>
        <el-select v-model="queryCriteria.transportType" size="mini" filterable style="width: 150px" placeholder="请选择运输方式">
          <el-option v-for="item in transportOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>品牌：</p>
        <el-input v-model="queryCriteria.brandName" size="mini" style="width: 150px" placeholder="请输入品牌" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtni">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
        <el-button size="small" type="danger" @click="onClickDeletes">批量删除</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>下载模板</span>
          <batch-import uploadUrl='/price/planSupplier/batchImport' @importSuccess='searchBtn' @triggerLoading='importLoading = !importLoading'/>
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          ref="tableRef"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          row-key="id"
          border
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          @selection-change="selectionChange"
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="类型" prop="msType" width="150px" align="center">
            <template slot-scope="scope">
              {{ getmsType(scope.row.msType) }}
            </template>
          </el-table-column>
          <el-table-column label="运输方式" prop="transportType" width="150px" align="center">
            <template slot-scope="scope">
              {{ gettransportType(scope.row.transportType) }}
            </template>
          </el-table-column>
          <el-table-column label="起始地" prop="startAddressName" width="150px" align="center" />
          <el-table-column label="目的地" prop="endAddressName" width="150px" align="center" />
          <el-table-column label="品牌" prop="brandName" width="150px" align="center" />
          <el-table-column label="费用类型" prop="priceType" width="150px" align="center">
            <template slot-scope="scope">
              {{ getpriceType(scope.row.priceType) }}
            </template>
          </el-table-column>
          <el-table-column label="单价" prop="price" width="150px" align="center" />
          <el-table-column label="开始时间" prop="startDate" width="150px" align="center" />
          <el-table-column label="结束时间" prop="endDate" width="150px" align="center" />
          <el-table-column label="创建人" prop="createByName" width="150px" align="center" />
          <el-table-column label="创建时间" prop="createTime" width="150px" align="center" />
          <el-table-column label="操作" min-width="260" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button size="mini" class="yellow-bg" type="primary" @click="changeClick(scope.row)">修改</el-button>
                <el-button size="mini" type="danger" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30, 40]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width="600px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">运输方式：</span>
              <span>{{ gettransportType(detailData.transportType) }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">线路：</span>
              <span>{{ detailData.startAddressName }} - {{ detailData.endAddressName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">类型：</span>
              <span>{{ getmsType(detailData.msType) }}</span>
            </div>
            <div class="baseInfoContentItem" v-if="detailData.transportType === 2">
              <span class="span1">供应商：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>价格设置</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">费用类型：</span>
              <span>{{ getpriceType(detailData.priceType) }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">品牌：</span>
              <span>{{ detailData.brandName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">单价：</span>
              <span>{{ detailData.price }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">开始时间：</span>
                <span>{{ detailData.startDate }}</span>
              </div>
              <div>
                <span class="span1">结束时间：</span>
                <span>{{ detailData.endDate }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">备注：</span>
              <span>{{ detailData.remake }}</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.operateRecordList" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">
                  {{ getTime(scope.row.createTime) }}
                </div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 新增 / 修改 -->
    <el-dialog :title="editDialogTitle" :visible.sync="editDialogVisible" width="650px" center @close="editDialogClose" :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="editData" label-width="140px" :rules="editRules" ref="ruleForm">
          <div-border label="基础信息" divStyle="margin-top: 10px">
            <el-row>
              <el-col>
                <el-form-item label="运输方式：" prop="transportType"  style="margin-top: 10px">
                  <el-radio-group v-model="editData.transportType" @change="supplierName(editData.transportType)">
                    <el-radio :label="1">公路</el-radio>
                    <el-radio :label="2">水路</el-radio>
                    <el-radio :label="3">联运</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="费用类型：" prop="priceType" style="margin-top: 10px">
                  <el-select v-model="editData.priceType" size="mini" style="width: 100%" filterable placeholder="请选择费用类型">
                    <el-option v-for="item in priceTypeOption" :key="item.id" :label="item.classaName" :value="item.classbName" />
                  </el-select>
                </el-form-item>
                <el-form-item label="路线：">
                  <el-input style="width: 40%" v-model="editData.startAddressName" placeholder="起始地：省份或港口" autocomplete="off" size="mini" />
                  <span style="margin: 0 20px;">-</span>
                  <el-input style="width: 40%" v-model="editData.endAddressName" placeholder="目的地：省份或港口" autocomplete="off" size="mini" />
                </el-form-item>
                <el-form-item label="类型：" prop="msType">
                  <el-radio-group v-model="editData.msType">
                    <el-radio :label="1">民生</el-radio>
                    <el-radio :label="2">非民生</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="供应商：" prop="supplierName" v-if="editData.transportType === 2">
                  <el-select v-model="editData.supplierName" style="width: 100%" filterable size="small" value-key="id" placeholder="请选择供应商">
                    <el-option v-for='item in supplierOption' :key='item.id' :label='item.name'
                               :value='item' ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div-border label="价格设置" divStyle="margin-top: 10px">
            <el-row>
              <el-col>
                
                <el-form-item label="品牌：" prop="brandName">
                  <el-select v-model="editData.brandName" size="mini" style="width: 100%" filterable placeholder="请选择品牌" multiple>
                    <el-option v-for="item in brandNameOption" :key="item.id" :label="item.brand" :value="item.brand" />
                  </el-select>
                </el-form-item>
                <el-form-item label="单价：" prop="price">
                  <el-input style="width: 100%" v-model="editData.price" type="number" placeholder="请输入单价" autocomplete="off" size="mini" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开始时间：" prop="startDate" style="margin-bottom: 20px">
                  <el-date-picker v-model="editData.startDate" size="mini" type="datetime" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间：" prop="endDate" style="margin-bottom: 20px">
                  <el-date-picker v-model="editData.endDate" size="mini" type="datetime" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" placeholder="选择结束时间" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  <el-input style="width: 450px" v-model="editData.remake" placeholder="请输入备注"  autocomplete="off" type="textarea" size="mini" />
                </el-form-item>
              </el-col>
            </el-row>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="editSureLoad" @click="editSureBtn">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="editDialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import divBorder from '@/components/divBorder';
  import {getHighwayParam, paramCategoryPageList} from '@/service/basicfile';
  import { getModelList, yearMonthPlanHighwayBrandList } from '@/service/vehiclelog';
  import {
    planSupplierAdd,
    planSupplierPageList,
    planSupplierUpdate,
    planSupplierDelete,
    planSupplierDetail,
    highwayLineSelectWaterSupplier
  } from '@/service/financial';
  import { formatDateTime } from '@/config/mUtils';
  import {getSupplier} from "@/service/warehouse";
  export default {
    components: { BatchImport, divBorder },
    data() {
      return {
        tableLoad: false,
        importLoading: false,
        queryCriteria: {
          msType: '', // 类型
          startAddressName: '', // 起始地
          endAddressName: '', // 目的地
          transportType: '', // 运输方式
          brandName: '', // 品牌
        },
        page: 1,
        rows: 10,
        typeOption: [
          { label: '全部', value: '' },
          { label: '民生', value: 1 },
          { label: '非民生', value: 2 },
        ],
        transportOption: [
          { label: '全部', value: '' },
          { label: '公路', value: 1 },
          { label: '水路', value: 2 },
          { label: '联运', value: 3 },
        ],
        priceTypeOption: [],
        priceTypeOption1: [],
        priceTypeOption2: [],
        priceTypeOptioni: [],
        brandNameOption: [],
        TableDatas: [], // 表格数据
        checkTableData: [],
        total: 0,
        editDialogTitle: '',
        editDialogVisible: false,
        supplierOption: [],
        editData: {
          transportType: '', // 运输方式
          startAddressName: '',  // 起始地
          endAddressName: '',  //目的地
          msType: '', // 类型
          supplierName: '',//供应商
          priceType: '', // 费用类型
          brandName: [], // 品牌
          price: '', // 单价
          startDate: '', // 开始时间
          endDate: '', // 结束时间
          remake: '' // 备注
        },
        editRules: {
          transportType: [
            {
              required: true,
              message: '请选择运输方式',
              trigger: 'change',
            },
          ],
          startAddressName: [
            {
              required: true,
              message: '请输入起始地',
              trigger: 'change',
            },
          ],
          endAddressName: [
            {
              required: true,
              message: '请输入目的地',
              trigger: 'change',
            },
          ],
          supplierName: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          msType: [
            {
              required: true,
              message: '请选择类型',
              trigger: 'change',
            },
          ],
          priceType: [
            {
              required: true,
              message: '请选择费用类型',
              trigger: 'change',
            },
          ],
          price: [
            {
              required: true,
              message: '请输入单价',
              trigger: 'change',
            },
          ],
          startDate: [
            {
              required: true,
              message: '请选择开始时间',
              trigger: 'change',
            },
          ],
          endDate: [
            {
              required: true,
              message: '请选择结束时间',
              trigger: 'change',
            },
          ],
        },
        editSureLoad: false,
        detailDialogVisible: false,
        detailData: {
          transportType: '', // 运输方式
          startAddressName: '',  // 起始地
          endAddressName: '',  //目的地
          msType: '', // 类型
          priceType: '', // 费用类型
          brandName: '', // 品牌
          price: '', // 单价
          startDate: '', // 开始时间
          endDate: '', // 结束时间
          operateRecordList: []
        },
      }
    },
    methods: {
      async detailClick(row) {
        const res = await planSupplierDetail({id: row.id});
        console.log(res);
        this.detailData = res.data;
        this.detailDialogVisible = true;
      },
      getmsType(val) {
        for (let i = 0; i < this.typeOption.length; i++) {
          if (this.typeOption[i].value == val) {
            return this.typeOption[i].label;
          }
        }
      },
      gettransportType(val) {
        for (let i = 0; i < this.transportOption.length; i++) {
          if (this.transportOption[i].value == val) {
            return this.transportOption[i].label;
          }
        }
      },
      getpriceType(val) {
        for (let i = 0; i < this.priceTypeOptioni.length; i++) {
          if (this.priceTypeOptioni[i].classbName == val) {
            return this.priceTypeOptioni[i].classaName;
          }
        }
      },
      searchBtni() {
        this.page = 1;
        this.searchBtn();
      },
      async searchBtn() {
        this.tableLoad = true;
        const { data, message, status } = await planSupplierPageList({
          ...this.queryCriteria,
          page: this.page,
          rows: this.rows,
        });
        if (status !== 0) return this.$message.error(message);
        this.total = data.total;
        // console.log(data);
        this.TableDatas = data.records;
        this.tableLoad = false;
      },
      resetBtn() {
        this.queryCriteria = {
          msType: '', // 类型
          startAddressName: '', // 起始地
          endAddressName: '', // 目的地
          transportType: '', // 运输方式
          brandName: '', // 品牌
        }
      },
      async supplierName(type) {
        if (type == 1) {
          const res = await getHighwayParam('');
          this.supplierOption = res.data;
          this.priceTypeOption = this.priceTypeOption1;
        } else if (type == 2) {
          const res = await highwayLineSelectWaterSupplier('');
          this.supplierOption = res.data;
          this.priceTypeOption = this.priceTypeOption2;
        } else if (type == 3) {
          this.priceTypeOption = this.priceTypeOption1;
        }
      },
      async addBtn() {
        this.editDialogTitle = '新增';
        this.editData = {};
        const {status, message, data} = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: '658625de271048b78be6f1f569211d14',
        });
        const resBrands = await yearMonthPlanHighwayBrandList();
        const brandNameRes = await getModelList();
        this.priceTypeOptioni = data.records;
        this.priceTypeOption1 = data.records;
        this.priceTypeOption2 = resBrands.data;
        this.priceTypeOption = [];
        this.brandNameOption = brandNameRes.data;
        this.editDialogVisible = true;
        
      },
      async changeClick(row) {
        this.editDialogTitle = '修改';
        this.editData = {
          ...row
        };
        this.editData['brandName'] = row.brandName.split('/')
        this.editData['priceType'] = String(this.editData['priceType']);
        const {status, message, data} = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: '658625de271048b78be6f1f569211d14',
        });
        const resBrands = await yearMonthPlanHighwayBrandList();
        const brandNameRes = await getModelList();
        this.priceTypeOptioni = data.records;
        this.priceTypeOption1 = data.records;
        this.priceTypeOption2 = resBrands.data;
        this.brandNameOption = brandNameRes.data;
        await this.supplierName(row.transportType)
        this.editDialogVisible = true;
      },
      deleteClick(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await planSupplierDelete({ids: id})
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.page = 1;
          this.searchBtn();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      onClickDeletes() {
        // console.log(this.checkTableData);
        this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await planSupplierDelete({ids: this.checkTableData.map(item => item.id).join(',')})
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.page = 1;
          this.searchBtn();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      download() {
        window.location.href = '/file/年月计划支出价格设置导入模板.xlsx';
      },
      exportData() {
        window.exportExcelAllFunc({
          type: 'post',
          url: '/price/planSupplier/export',
          name: '年月计划支出价格设置表',
        });
      },
      contractSizeChange(sizes) {
        this.rows = sizes;
        this.page = 1;
        this.searchBtn();
      },
      contractCurrentChange(page) {
        this.page = page;
        this.searchBtn();
      },
      selectionChange(rows) {
        this.checkTableData = rows;
      },
      editDialogClose() {
        // this.$refs.ruleForm.resetFields();
        this.$refs.ruleForm.resetFields();
      },
      async editSureBtn() {
        let res
        if (this.editDialogTitle == '新增') {
          res = await planSupplierAdd({
            msType: this.editData.msType,
            transportType: this.editData.transportType,
            startAddressName: this.editData.startAddressName,
            endAddressName: this.editData.endAddressName,
            supplierId:  this.editData.transportType === 2 ? this.editData.supplierName.id : '' ,
            supplierName: this.editData.transportType === 2 ? this.editData.supplierName.name : '',
            brandName: this.editData.brandName.map(item=>item).join('/'),
            priceType: this.editData.priceType,
            price: this.editData.price,
            startDate: this.editData.startDate,
            endDate: this.editData.endDate,
            remake: this.editData.remake,
          });
        } else {
          res = await planSupplierUpdate({
            id: this.editData.id,
            msType: this.editData.msType,
            transportType: this.editData.transportType,
            startAddressName: this.editData.startAddressName,
            endAddressName: this.editData.endAddressName,
            supplierId: this.editData.supplierName.id,
            supplierName: this.editData.supplierName.name,
            brandName: this.editData.brandName.map(item=>item).join('/'),
            priceType: this.editData.priceType,
            price: this.editData.price,
            startDate: this.editData.startDate,
            endDate: this.editData.endDate,
            remake: this.editData.remake,
          });
        }

        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.searchBtn();
        this.editDialogVisible = false;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      getTime(time) {
        return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
      },
    },
    async mounted() {
      const {status, message, data} = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: '658625de271048b78be6f1f569211d14',
      });
      this.priceTypeOptioni = data.records;
    },

  }
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            ::v-deep {
              .el-table td,
              .el-table th {
                padding: 0;
              }

              .cell {
                font-size: 10px;
                padding: 0;
              }
            }

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }
  }
</style>
